import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import AnaSayfa from './pages/AnaSayfa';
import YapayZekaAsistani from './pages/YapayZekaAsistani';
import IzinYonetimi from './pages/IzinYonetimi';
import ShiftYonetimi from './pages/ShiftYonetimi';
import UygunRandevuBulucu from './pages/UygunRandevuBulucu';
import EtkinlikHastaKaydi from './pages/EtkinlikHastaKaydi';
import ReklamYonetimi from './pages/ReklamYonetimi';
import RandevuListesi from './pages/RandevuListesi';
import HarcamaKaydi from './pages/HarcamaKaydi';
import HarcamaKaydiGelismis from './pages/HarcamaKaydiGelismis';
import CallCenter from './pages/CallCenter';
import ResmiTatiller from './pages/ResmiTatiller';
import RandevuEkrani from './pages/RandevuEkrani';
import HastaKayit from './pages/HastaKayit';
import HastaKabul from './pages/HastaKabul';
import HatirlatmaSms from './pages/HatirlatmaSms';
import TopluSms from './pages/TopluSms';
import HastaCari from './pages/HastaCari';
import HastaEFatura from './pages/HastaEFatura';
import KurumFaturalari from './pages/KurumFaturalari';
import KisiselAsistan from './pages/KisiselAsistan';
import Layout from './components/Layout';
import { oturumKullanicisi, yetkiVar, callYetkiVar, klasikYetkiVar, bankoYetkiVar } from './yetki';
import './App.css';

function KorunanRoute({ children }) {
  const jeton = localStorage.getItem('jeton');
  // Jeton yoksa oturum yok. Bu kontrol aynı zamanda jeton öncesi açılmış eski oturumları da
  // geçersiz kılar. Asıl güvenlik sunucudadır — burada yapılan sadece ekranı doğru yönlendirmek.
  const kullanici = oturumKullanicisi();
  return (jeton && kullanici.yetkiler) ? children : <Navigate to="/login" replace />;
}

// Menüde gizlenen ekrana URL'yi doğrudan yazarak girilmesini de engeller.
// Yetki numaraları ve menü eşleşmesi için bkz. src/yetki.js.
function YetkiliRoute({ yetki, call, klasik, banko, children }) {
  // yetki  = TEKN.YETK_WEB_x   (FizyofiPlus menü yetkileri)
  // call   = TEKN.YETK_CALL_x  (Call Center kendi kolon ailesini kullanır)
  // klasik = TEKN.YETKx        (Dr.Plazma'nın klasik yetkileri, VB6 ile ORTAK)
  // banko  = TEKN.VEZNE1/2/3   (VB6 Banko modülünün yetkileri, 2026-09-20)
  return (yetkiVar(yetki) && callYetkiVar(call) && klasikYetkiVar(klasik) && bankoYetkiVar(banko))
    ? children : <Navigate to="/" replace />;
}

function App() {
  return (
    <BrowserRouter basename={process.env.REACT_APP_BASENAME || ''}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<KorunanRoute><Layout /></KorunanRoute>}>
          {/* Panel ekranı kaldırıldı (kullanıcı talebi: 2026-09-06); giriş sonrası
              yalnızca logo duran bir ana sayfa açılıyor, işler üst menüden seçiliyor. */}
          <Route index element={<AnaSayfa />} />
          {/* Yetki gerektirmez, giriş yapan herkese açık. */}
          <Route path="yapay-zeka" element={<YapayZekaAsistani />} />
          <Route path="izin" element={<YetkiliRoute yetki={2}><IzinYonetimi /></YetkiliRoute>} />
          <Route path="shift" element={<YetkiliRoute yetki={3}><ShiftYonetimi /></YetkiliRoute>} />
          <Route path="uygun-randevu" element={<YetkiliRoute yetki={4}><UygunRandevuBulucu /></YetkiliRoute>} />
          {/* Randevu Modülü 4. ekran — Hatırlatma SMS (VB6 H_SMS_FORM.frm), 2026-09-21. */}
          <Route path="hatirlatma-sms" element={<YetkiliRoute yetki={8}><HatirlatmaSms /></YetkiliRoute>} />
          {/* Randevu Modülü — Toplu SMS (VB6 SERBEST_SMS.frm), 2026-09-21. */}
          <Route path="toplu-sms" element={<YetkiliRoute yetki={8}><TopluSms /></YetkiliRoute>} />
          <Route path="etkinlik-hasta-kaydi" element={<YetkiliRoute yetki={5}><EtkinlikHastaKaydi /></YetkiliRoute>} />
          <Route path="reklam-yonetimi" element={<YetkiliRoute yetki={6}><ReklamYonetimi /></YetkiliRoute>} />
          <Route path="randevu-listesi" element={<YetkiliRoute yetki={7}><RandevuListesi /></YetkiliRoute>} />
          <Route path="harcama-kaydi" element={<YetkiliRoute yetki={9}><HarcamaKaydi /></YetkiliRoute>} />
          <Route path="harcama-gelismis" element={<YetkiliRoute yetki={10}><HarcamaKaydiGelismis /></YetkiliRoute>} />
          <Route path="call-center" element={<YetkiliRoute call={1}><CallCenter /></YetkiliRoute>} />
          <Route path="resmi-tatiller" element={<YetkiliRoute klasik={21}><ResmiTatiller /></YetkiliRoute>} />
          <Route path="randevu-ekrani" element={<YetkiliRoute yetki={8}><RandevuEkrani /></YetkiliRoute>} />
          <Route path="kurum-faturalari" element={<YetkiliRoute klasik={45}><KurumFaturalari /></YetkiliRoute>} />
          {/* Banko Modülü — Hasta Kayıt (VB6 KAYT2.frm); yetki VB6 ile aynı: TEKN.VEZNE1 (2026-09-20). */}
          <Route path="hasta-kayit" element={<YetkiliRoute banko={1}><HastaKayit /></YetkiliRoute>} />
          {/* Banko Modülü — Hasta Kabul (VB6 KABUL.frm); ekrana giriş TEKN.VEZNE1 (2026-09-21). */}
          <Route path="hasta-kabul" element={<YetkiliRoute banko={1}><HastaKabul /></YetkiliRoute>} />
          {/* Banko Modülü — Hasta Cari Hesapları (VB6 CAR_H.frm), 2026-09-21. */}
          <Route path="hasta-cari" element={<YetkiliRoute banko={1}><HastaCari /></YetkiliRoute>} />
          {/* Banko Modülü — Hasta e-Fatura (VB6 ESMM_H_NEW.frm), 2026-09-21. */}
          <Route path="hasta-efatura" element={<YetkiliRoute banko={1}><HastaEFatura /></YetkiliRoute>} />
          <Route path="kisisel-asistan" element={<YetkiliRoute yetki={21}><KisiselAsistan /></YetkiliRoute>} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
